import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { SmsCp } from 'src/app/core/api/models';

@Directive({
  selector: '[smsSenderAgent]',
  standalone: true,
})
export class SmsSenderAgentDirective implements OnInit {
  @Input('smsSenderAgent') smsSenderAgent: SmsCp;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className += this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'badge tw-font-bold ';

    switch (this.smsSenderAgent) {
      case SmsCp.Armaghan:
        classList += 'badge-light-pink tw-w-[80px]';
        break;

      case SmsCp.Asanak:
        classList += 'badge-light-orange tw-w-[80px]';
        break;

      case SmsCp.Avanak:
        classList += 'badge-light-teal tw-w-[80px]';
        break;

      case SmsCp.PishgamRayan:
        classList += 'badge-light-navyBlue tw-w-[80px]';
        break;

      case SmsCp.RahyabPG:
        classList += 'badge-light-success tw-w-[100px]';
        break;

      case SmsCp.RahyabRG:
        classList += 'badge-light-blue tw-w-[100px]';
        break;

      case SmsCp.Magfa:
        classList += 'badge-light-info tw-w-[80px]';
        break;

      case SmsCp.SocialNetworks:
        classList += 'badge-light-slate tw-w-[100px]';
        break;

      case SmsCp.SLS:
        classList += 'badge-light-warning tw-w-[100px]';
        break;

      case SmsCp.Idehgate:
        classList += 'badge-light-danger tw-w-[80px]';
        break;

      case SmsCp.PishgamRayan2:
        classList += 'badge-light-warning tw-w-[100px]';
        break;

      case SmsCp.Irancell:
        classList += 'badge-light-danger tw-w-[100px]';
        break;

      case SmsCp.MCI:
        classList += 'badge-light-primary tw-w-[100px]';
        break;

      case SmsCp.Kando:
        classList += 'badge-light-ministry tw-w-[100px]';
        break;

      case SmsCp.Rightel:
        classList += 'badge-light-primary tw-w-[100px]';
        break;

      case SmsCp.PishgamRayan3:
        classList += 'badge-light-pink tw-w-[100px]';
        break;

      case SmsCp.Mxb:
        classList += 'badge-light-success tw-w-[100px]';
        break;

      case SmsCp.Kando:
        classList += 'badge-light-orange tw-w-[100px]';
        break;

      default:
        classList += 'badge-light tw-w-[100px]';
        break;
    }

    return classList;
  }
}
